import { render } from "./AdminViewUser.vue?vue&type=template&id=55feeff1"
import script from "./AdminViewUser.vue?vue&type=script&lang=js"
export * from "./AdminViewUser.vue?vue&type=script&lang=js"

import "./AdminViewUser.vue?vue&type=style&index=0&id=55feeff1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__